module.exports = __webpack_public_path__ + "static/media/quest.0e3661db.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Repertoire/assets/quest.png
// module id = 521
// module chunks = 0